import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { faBell } from '@fortawesome/free-regular-svg-icons';

import { GsapService } from '../services/gsap.service';
import { HaylieService } from '../services/haylie.service';

@Component({
  selector: 'app-master-header',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './master-header.component.html',
  styleUrls: ['./master-header.component.css']
})
export class MasterHeaderComponent implements OnInit {
  FAIcon = faEllipsisV;
  faBell = faBell;
  player_plugged = false;

  constructor(private gsap: GsapService, private haylie: HaylieService) { }

  ngOnInit(): void {
    this. player_plugged = true;
  }
  header_trg(p_action:string):void {
    if (p_action == "sidebar")
      this.gsap.anima_trg("sidebar", "open");
    else {
      this.haylie.player_compass(false, 'home');

      this.gsap.player_pages(p_action);
    }
  
  }
  

}
